class CustomerRegisterForm extends HTMLElement {
    constructor() {
        super();
        this.form_el = document.getElementById("create_customer");
        this.password = this.form_el.querySelector('input[name="customer[password]');
        this.passwordConfirmed = this.form_el.querySelector('input[name="customer[password_confirmation]');
        this.email = this.form_el.querySelector('input[type="email"]');
        this.firstName =  this.form_el.querySelector('input[name="customer[first_name]"]');
        this.lastName =  this.form_el.querySelector('input[name="customer[last_name]"]');
        this.privacy = this.form_el.querySelector('input[name="customer_privacy"]');
        this.errors_container = this.form_el.querySelector(".custom-errors-js");
    }

    connectedCallback() {
        this.init();
    }

    init() {

        this.form_el.addEventListener("submit",  (evt) => {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            // validate -> field is not blank

            const validFirstName = this.validateName(this.firstName);
            const validLastName = this.validateName(this.lastName);

            const validPsw = this.validatePsw();
            const validMail = this.validateMail();
            const validPswConfirmed = this.validatePswConfirmed();
            const comparePswConfirmed = this.comparePswConfirmed();
            const isChecked = this.isPrivacyChecked();
            const validForm = this.handleErrors(validFirstName, validLastName, validPsw, validMail, validPswConfirmed, comparePswConfirmed, isChecked);

            if (validForm) {
                this.submitForm();
            }
            else{
                this.errors_container.style.display = "block";
            }
        });
    }

    handleErrors(validFirstName, validLastName, validPsw, validMail, validPswConfirmed, comparePswConfirmed, isChecked) {
        let valid = true;

        const nameError = this.querySelector('#first_name-error-js');
        const lastNameError = this.querySelector('#last_name-error-js');

        nameError.style.display =  validFirstName ? "block" : "none"
        lastNameError.style.display =  validLastName ? "block" : "none"

        if (validFirstName) {
            const nameError = this.querySelector('#first_name-error-js');
            nameError.innerHTML = 'Name blank';
            valid = false
        }

        if (validLastName) {
            const lastNameError = this.querySelector('#last_name-error-js');
            lastNameError.innerHTML = 'Last name blank';
            valid = false
        }

        if (validMail) {
            this.mailErrorMsg();
            valid = false
        }

        if (validPsw) {
            this.pswErrorMsg();
            valid = false
        }

        if (validPswConfirmed) {
            this.pswConfirmedErrorMsg();
            valid = false
        }

        if (comparePswConfirmed) {
            this.pswValidateErrorMsg();
            valid = false
        }

        if (isChecked) {
            this.isPrivacyChecked();
            valid = false
        }
        return valid
    }

    // privacy checked 
    isPrivacyChecked() {
        if (!this.privacy.checked) {
            this.checkMsg = this.querySelector('#checkbox-error-js');
            this.checkMsg.style.display = "block"
            this.checkMsg.innerHTML = errorMessages.checkError;
            return true
        }

        this.querySelector('#checkbox-error-js').style.display = "none";
        return false
    }

    validateName(element) {
        return !element.value.length ;
    }

    // confirm password disabled
    disabledConfirmPassword
    // mail validation
    validateMail() {
        const mailBlank = this.isMail();
        if (mailBlank) {
            return true;
        }
        this.querySelector('#mail-error-js').style.display = "none";
        return false;
    }

    isMail() {
        const mailValue = this.email.value.trim();
        return mailValue === '';
    }


    mailErrorMsg() {
        this.mailMsg = this.querySelector('#mail-error-js');
        this.mailMsg.style.display = "block"
        this.mailMsg.innerHTML = errorMessages.mailError;
    }


    // passwoerd validation
    validatePsw() {
        const pswBlank = this.isPsw();
        if (pswBlank) {
            return true;
        }
        this.querySelector('#password-error-js').style.display = "none";
        return false;
    }
    isPsw() {
        const passwordValue = this.password.value.trim();
        return passwordValue === '';
    }

    pswErrorMsg() {
        this.pswMsg = this.querySelector('#password-error-js');
        this.pswMsg.style.display = "block"
        this.pswMsg.innerHTML = errorMessages.pswError;
    }

    // confirm password
    validatePswConfirmed() {
        const pswConfirmedBlank = this.isPswConfirmed();
        if (pswConfirmedBlank) {
            return true;
        } else {
            this.querySelector('#password-confirmed-error-js').style.display = "none";
        }
        return false;
    }
    isPswConfirmed() {
        const passwordConfirmedValue = this.passwordConfirmed.value.trim();
        if (passwordConfirmedValue === '') {
            return true;
        }
        return false
    }
    pswConfirmedErrorMsg() {
        this.pswConfirmedMsg = this.querySelector('#password-confirmed-error-js');
        this.pswConfirmedMsg.style.display = "block"
        this.pswConfirmedMsg.innerHTML = errorMessages.pswError;
    }

    // password and confirm password validate
    comparePswConfirmed() {
        const pswConfirmedBlank = this.isPswsValidate();
        if (pswConfirmedBlank) {
            return true
        } else {
            this.querySelector('#password-confirmed-error-js').style.display = "none";
        }
        return false
    }
    isPswsValidate() {
        const passwordConfirmedValue = this.passwordConfirmed.value.trim();
        const passwordValue = this.password.value.trim();
        if (passwordConfirmedValue != '' && passwordConfirmedValue != passwordValue) {
            return true;
        }
        return false
    }
    pswValidateErrorMsg() {
        this.pswConfirmedMsg = this.querySelector('#password-confirmed-error-js');
        this.pswConfirmedMsg.style.display = "block"
        this.pswConfirmedMsg.innerHTML = errorMessages.confirmedPswError;
    }

    // save in local storage
    sendData() {
        let localStorageData = JSON.parse(localStorage.getItem('data')) || [];
        localStorageData.push({
            '$email': this.email.value,
            '$password': this.password.value,
            '$passwordConfirmed': this.passwordConfirmed.value,
            'Accepts Marketing': true
        });
        localStorage.setItem('data', JSON.stringify(localStorageData));
        this.submitForm();
    }


    submitForm() {
        this.form_el.submit();
    }
}

customElements.define('customer-registration-form', CustomerRegisterForm);
